/**
 * LandingLayout Component
 * Wrapper for landing pages with common elements
 * Note: Theme context and ThemeSwitcher are now provided at App level
 */

import React from 'react';

interface LandingLayoutProps {
  children: React.ReactNode;
}

export const LandingLayout: React.FC<LandingLayoutProps> = ({ children }) => {
  return <>{children}</>;
};
